import { OnInit, OnChanges, SimpleChanges, Component, ViewChild } from '@angular/core';
import { WizardStep } from '../../../wizard/wizard.component';
import { ReservationRegularWizardService, ReservationWizardService } from '../../../services/wizard/reservation/reservation.wizard.service';
import { Question } from '../../../model/question';
import { ReservationQuestion } from '../../../model/reservation-question';
import { QuestionComponent } from '../../question/question.component';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-reservation-question-component',
  templateUrl: './reservation-question.component.html',
  styleUrls: ['./reservation-question.component.css']
})
export class ReservationQuestionComponent implements OnInit, WizardStep {

  loading: boolean;
  reservationQuestion: ReservationQuestion;
  isInit: boolean;
  @ViewChild('questionComponent', {static: false}) questionComponent: QuestionComponent;

  constructor(private reservationWizardService: ReservationWizardService
    , private notificationToastService: NotificationToastService) {
    this.reservationQuestion = reservationWizardService.reservationQuestion;
  }

  get completed(): boolean { return this.reservationWizardService.reservationQuestion.IsQuestionsFinish(); }

  get valid(): boolean {
    return this.completed;
  }


  async activate() {
    if (!this.reservationWizardService.reservationQuestion.IsQuestionsFinish()) {
      try {
        this.loading = true;
        await this.reservationWizardService.loadReservationQuestions();
        this.reservationQuestion = this.reservationWizardService.reservationQuestion;
        if ( this.reservationQuestion.Answers.length ===  this.reservationQuestion.Questions.length) {
          this.reservationQuestion.QuestionsFinish = true;
        } else  {
          this.questionComponent.redo();
          if (this.reservationQuestion.Questions.length === 0) {
            this.reservationQuestion.QuestionsFinish = true;
          }
          setTimeout(() => this.questionComponent.setFocus(), 0);
        }
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Reserva');
      } finally {
        this.loading = false;
      }
    }
  }

  onQuestionsRedo(): void {
    this.reservationQuestion.QuestionsFinish = false;
    this.reservationWizardService.clearAllReservationSlot();
  }

  onQuestionsFinished(isBlock: boolean): void {
    this.reservationQuestion.QuestionsFinish = !isBlock;
  }

  save() {
    this.reservationWizardService.setAnswers(this.reservationQuestion.Answers,
      this.reservationQuestion.Questions);
  }

  ngOnInit(): void {
    this.isInit = true;
  }
}
